import { render, staticRenderFns } from "./DataRecords.vue?vue&type=template&id=35e7c281&scoped=true&"
import script from "./DataRecords.vue?vue&type=script&lang=js&"
export * from "./DataRecords.vue?vue&type=script&lang=js&"
import style0 from "./DataRecords.vue?vue&type=style&index=0&id=35e7c281&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e7c281",
  null
  
)

export default component.exports